export const ENUM_CERTIFICATES_STATUS={
    VIGENTE:'VIGENTE',
    VENCIDO:'VENCIDO',
    REVOCADO:'REVOCADO'
}